/* eslint-disable camelcase */
import React from 'react';
import {
  MinusCircleOutlined,
  EditOutlined,
  SketchOutlined,
  ExperimentOutlined,
  BuildOutlined,
  CheckCircleOutlined,
  RocketOutlined,
} from '@ant-design/icons';

const devStageConfig = {
  not_started: {
    icon: <MinusCircleOutlined style={{ color: '#8C8C8C' }} />,
  },
  shaping: {
    icon: <EditOutlined style={{ color: '#4B9FFF' }} />,
  },
  design: {
    icon: <SketchOutlined style={{ color: '#FFA500' }} />,
  },
  feasibility_analysis: {
    icon: <ExperimentOutlined style={{ color: '#E5A600' }} />,
  },
  development: {
    icon: <BuildOutlined style={{ color: '#6ABF4B' }} />,
  },
  uat: {
    icon: <CheckCircleOutlined style={{ color: '#4B9FFF' }} />,
  },
  in_production: {
    icon: <RocketOutlined style={{ color: '#E5493A' }} />,
  },
};

export default devStageConfig;
